import { useTheme } from "@mui/material/styles";

const Styles = () => {
  const theme = useTheme();
  

  
  return {
    drawer: {
      width:'300px', 
      backgroundColor:theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      justifyCOntent:'center'
    },
    icon: {color:'#FFF'},
    text: {color:'#FFF'},
  };
};

export default Styles;
